import {envBoolean, envEnum, envString, validateAndCreate} from '@specials/frontend-envobj';

export enum Environment {
  Prod = 'prod',
  Stage = 'stage',
  Local = 'local',
}

// Инициализируем тут, потому что нужны на уровне выше чем DiProvider
export const envs = validateAndCreate({
  APP_ENVIRONMENT: envEnum<Environment>(process.env.APP_ENVIRONMENT, Environment),
  APP_SENTRY_DSN: envString(process.env.APP_SENTRY_DSN),
  APP_PROJECT_URL: envString(process.env.APP_PROJECT_URL),
  APP_PROJECT_API_URL: envString(process.env.APP_PROJECT_API_URL),
  APP_SSO_CLIENT_URL: envString(process.env.APP_SSO_CLIENT_URL),
  APP_SSO_API_URL: envString(process.env.APP_SSO_API_URL),
  APP_POST_COMPLETE_REDIRECT_PATH: envString(process.env.APP_POST_COMPLETE_REDIRECT_PATH),
  APP_PROJECT_API_MOCK_ENABLED: envBoolean(process.env.APP_PROJECT_API_MOCK_ENABLED),
  APP_PROJECT_AUTH_API_MOCK_ENABLED: envBoolean(process.env.APP_PROJECT_AUTH_API_MOCK_ENABLED),
  APP_RESOURCES_USE_LOCAL: envBoolean(process.env.APP_RESOURCES_USE_LOCAL),
  APP_RESOURCES_URL: envString(process.env.APP_RESOURCES_URL),
  APP_STATIC_BASE_URL: envString(process.env.APP_STATIC_BASE_URL),
  APP_STATIC_URL: envString(process.env.APP_STATIC_URL),
  APP_ANALYTICS_PRODUCT_NAME: envString(process.env.APP_ANALYTICS_PRODUCT_NAME),
  APP_SECRET_CODE_ENABLED: envBoolean(process.env.APP_SECRET_CODE_ENABLED),
  APP_PROJECT_API_USE_CQRS: envBoolean(process.env.APP_PROJECT_API_USE_CQRS),
  APP_SENTRY_PAYLOAD_POSTFIX: envString(process.env.APP_SENTRY_PAYLOAD_POSTFIX),
});
